import { faker } from "@faker-js/faker";

import type {
  CreateAccount201,
  CreateAccount403,
  CreateAccountMutationRequest,
  CreateAccountMutationResponse,
  CreateAccountPathParams,
} from "../models/CreateAccount";
import { createAccount } from "./createAccount";
import { createModifyAccountRequest } from "./createModifyAccountRequest";

export function createCreateAccountPathParams(
  override: NonNullable<Partial<CreateAccountPathParams>> = {},
): NonNullable<CreateAccountPathParams> {
  return {
    ...{ workspace_id: faker.number.int() },
    ...override,
  };
}

/**
 * @description OK
 */
export function createCreateAccount201(
  override: NonNullable<Partial<CreateAccount201>> = {},
): NonNullable<CreateAccount201> {
  return {
    ...{ account: createAccount() },
    ...override,
  };
}

/**
 * @description Forbidden
 */
export function createCreateAccount403(
  override: NonNullable<Partial<CreateAccount403>> = {},
): NonNullable<CreateAccount403> {
  return {
    ...{ error: {} },
    ...override,
  };
}

export function createCreateAccountMutationRequest(
  override: NonNullable<Partial<CreateAccountMutationRequest>> = {},
): NonNullable<CreateAccountMutationRequest> {
  return {
    ...{ account: createModifyAccountRequest() },
    ...override,
  };
}

/**
 * @description OK
 */
export function createCreateAccountMutationResponse(
  override: NonNullable<Partial<CreateAccountMutationResponse>> = {},
): NonNullable<CreateAccountMutationResponse> {
  return {
    ...{ account: createAccount() },
    ...override,
  };
}
